<template>
	<div class="pdp-mastercard-callout flex-row">
		<picture>
			<source srcset="/assets/images/credit-cards/blain-card-pdp.webp" type="image/webp" />
			<source srcset="/assets/images/credit-cards/blain-card-pdp.jpg" type="image/jpeg" />
			<img class="pdp-mastercard-callout__thumbnail" alt="" src="/assets/images/credit-cards/blain-card-pdp.jpg" />
		</picture>

		<div class="pdp-mastercard-callout__content">
			<p class="pdp-mastercard-callout__title">Buy Now. Pay Over Time.</p>
			<p class="pdp-mastercard-callout__description">Get <strong>0% intro APR financing</strong><sup>2</sup> for <strong>12 billing cycles</strong> on purchases of <strong>$500 or more at Blain's</strong> with a Blain's Farm &amp; Fleet Rewards Mastercard®</p>
			<a class="pdp-mastercard-callout__link" href="/mastercard">Apply Now <icon name="chevron-right" /></a>
		</div>
	</div>
</template>

<script>
import Icon from '../../components/Icon.vue';
export default {
	name: 'ProductMastercardCallout',
	components: {
		Icon
	}
};
</script>

<style lang="less" scoped>
 @import "../../../less/_mixins";
.pdp-mastercard-callout {
	display: flex;
	/* Saved for standard positioning at the bottom of the right column
	flex-direction: column;
	margin-top: 1em;
	padding: 0.625rem 0.75rem;
	*/

	/*
	The below two lines are for the purpose of a temporary repositioning of this element on the PDP,
	to increase its prominence during the month of November 2022 to hit incentive targets. This should be
	revisited with client at the end of November for possible reverting to original positioning.
	*/
	flex-direction: row;
	padding: 0 0 0.625rem;

	.tablet-and-up-styles({
		flex-direction: row;
	});

	&__thumbnail {
		width: 62px;
		height: 42px;

		.tablet-and-up-styles({
			margin-right: 0.625rem;
			margin-top: 0.25rem;
		});
	}

	&__content {
		.mobile-styles({
			margin-top: 0.25rem;
			padding-left: 0.75rem;
		});
	}

	&__title {
		font-weight: bold;
		line-height: 1rem;
		font-size: 0.8rem;
		color: #875200;
		margin: 0;
		margin-bottom: 0.25rem;
	}

	&__description {
		font-size: 0.75rem;
		line-height: 1rem;
		color: #432900;
		margin: 0;
		margin-bottom: 0.375rem;
	}

	&__link {
		display: flex;
		align-items: center;
		font-size: 0.75rem;
		font-weight: 500;
		line-height: 1.2rem;
		color: #1D6C9D;
		text-decoration: none;

		.tablet-only-styles({
			margin-bottom: 7px;
		});
	}

	sup {
		vertical-align: super;
		font-size: smaller;
	}
}

@media screen and (max-width: @tablet) {
}
@media screen and (max-width: @tablet) {
}
@media screen and (max-width: @mobile-small) {
}
</style>